import {
  Component,
  HostListener,
  Injector,
  Input,
  OnInit,
  Renderer2,
  ChangeDetectionStrategy
} from '@angular/core'
import { AbstractComponent, UtilHelper } from 'lib-trend-core'
import { debounceTime, fromEvent, Subscription } from 'rxjs'
import { environment } from '../../../environments/environment'

@Component({
    selector: 'sidebar-component',
    templateUrl: './sidebar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SideBarComponent extends AbstractComponent implements OnInit {
  @Input() sidenav!: MouseEvent

  private resizeSubscription!: Subscription

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement
    const backdrop = document.getElementById('custom-backdrop')

    if (backdrop && target === backdrop) {
      this.closeSidebar()
    }
  }

  constructor(
    public injector: Injector,
    private renderer: Renderer2,
  ) {
    super(injector)
  }

  ngOnInit(): void {
    this.setInitialSidebar()
    this.onResizeScreen()
    this.listenToResize()
  }

  override ngOnDestroy(): void {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe()
    }
  }

  setInitialSidebar() {
    const width = window.innerWidth
    let newState: string

    if (width < 768) {
      newState = 'full'
    } else if (width < 992) {
      newState = 'condensed'
    } else {
      newState = 'default'
    }

    this.renderer.setAttribute(
      document.documentElement,
      'data-sidenav-size',
      newState,
    )

    document.getElementsByTagName('body')[0].classList.add('show')
    document.documentElement.classList.add('menuitem-active')
  }

  onResizeScreen(): void {
    const width = window.innerWidth
    let newState: string

    if (width < 768) {
      newState = 'full'
    } else if (width < 992) {
      newState = 'condensed'
    } else {
      newState = 'default'
    }

    const currentState =
      document.documentElement.getAttribute('data-sidenav-size')

    if (currentState !== newState) {
      this.renderer.setAttribute(
        document.documentElement,
        'data-sidenav-size',
        newState,
      )
    }
  }

  closeSidebar(): void {
    const width = window.innerWidth

    if (width > 768) {
      return
    }

    const backdrop = document.getElementById('custom-backdrop')

    if (!backdrop) return

    document.documentElement.classList.remove('sidebar-enable')
    document.body.style.overflow = ''
    backdrop.remove()
  }

  private listenToResize(): void {
    this.resizeSubscription = fromEvent(window, 'resize')
      .pipe(debounceTime(200))
      .subscribe(() => this.onResizeScreen())
  }

  goToWebAdmin() {
    const idUser = super.getIDCurrentUser()
    const idCompany = super.getIDCurrentCompany()
    const base64 = UtilHelper.generateTokenTowardsApps(idUser, idCompany)
    window.open(
      `${environment.trendWebAdminUrl}/redirect?token=${base64}`,
      '_blank',
    )
  }
}
